import { unTranslationKey, } from "./generated-i18n/TranslationKeys";
import { I18n } from "./services/I18n";
export * from "./generated-i18n/pendolino/Keys";
export { t as commonT } from "./generated-i18n/common/Keys";
export function translate(key, params) {
    return I18n.t(unTranslationKey(key), params !== null && params !== void 0 ? params : {});
}
